import "cropperjs/dist/cropper.css";
import "ol/ol.css";
import * as React from "react";
import { render } from "react-dom";
import "regenerator-runtime/runtime";
import "video.js/dist/video-js.css";
import App from "./components/App";

const rootEl = document.getElementById("root");

render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  rootEl,
);

if (process.env.NODE_ENV === "production") {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((registration) => {
          console.log("SW registered: ", registration);
        })
        .catch((registrationError) => {
          console.log("SW registration failed: ", registrationError);
        });
    });
  }
}
